import { Component, OnInit } from '@angular/core';
import { switchMap, tap, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { FormControl } from '@angular/forms';
import { LoadingService } from 'src/app/utils/loading/loading.service';
import { BehaviorSubject } from 'rxjs';
import { AcordarUtils } from 'src/app/utils/acordar/utils.acordar';
import { ProvincesSvgService } from 'src/app/services/provinces-svg.service';
import { AcordarService } from 'src/app/services/acordar.service';

@Component({
	selector: 'app-oferta-provincia',
	templateUrl: './oferta-provincia.component.html',
	styleUrls: [ './oferta-provincia.component.scss' ]
})
export class OfertaProvinciaComponent implements OnInit {
	_results: BehaviorSubject<any> = new BehaviorSubject([]);
	results: any = [];
	showMasInfo: any = null;
	provInhabilitado: any = null;
	// precioMouseOver: boolean = false;
	precioMouseEnter: BehaviorSubject<boolean> = new BehaviorSubject(false);
	prov_id: any;

	//pagination
	pagination: Array<number>;
	currentPage: number;
	lastPage: number;

	partidoControl = new FormControl(null);
	productoControl = new FormControl(null);
	provinciaControl = new FormControl(null);
	marcaControl = new FormControl(null);
	proveedorControl = new FormControl(null);
	solicitudControl = new FormControl(null);

	cargandoBusqueda: boolean;
	params = [];
	subscription: any;
	optsProvs = [];
	busquedaAvanzada: boolean;
	showCross: boolean = false;
	cargaInicial: boolean = true;

	constructor(
		private acordarService: AcordarService,
		private _route: ActivatedRoute,
		private loadingService: LoadingService,
		private getProvs: ProvincesSvgService
	) {
		this.busquedaAvanzada = false;
	}
	showBusqueda() {
		if (this.busquedaAvanzada) {
			this.busquedaAvanzada = false;
		} else {
			this.busquedaAvanzada = true;
		}
	}

	ngOnInit() {
		this.optsProvs = this.getProvs.provinces_svg
			.map((prov) => prov)
			.sort((a, b) => AcordarUtils.orderAlphabetically(a.gid, b.gid));
		this._route.paramMap
			.pipe(
				tap((params: ParamMap) => {
					this.prov_id = params.get('id_provincia');
					console.log(this.prov_id);
					if (this.prov_id !== null) {
						this.params.push({ nombre: 'ubicacion.provincia.nombre_normalizado', value: this.prov_id.toUpperCase() });
						this.showCross = true;
					}
					this.loadingService.show();
				}),
				switchMap(() =>
					this.acordarService
						.getBuscarOfertas(1, this.params)
						.pipe(finalize(() => this.loadingService.hide()))
				)
			)
			.subscribe(
				(response: any) => {
					if (response.result.length > 0) {
						response.result.map((r) => {
							this.acordarService.getProductoPorNumCat(r, 1, this.params).subscribe(
								(rta) => {
									if (rta.result.ofertas.length > 0) {
										this.cargaInicial = false;
									}
									this.loadingService.hide();
									this.results.push(this.mapResults(rta.result));
									this._results.next(this.results);
								},
								(error) => {
									this.clearData();
									this.loadingService.hide();
								}
							);
						});
						this.paginate(response);
					}
				},
				(error) => {
					this.clearData();
					this.loadingService.hide();
				}
			);
		this.busquedaSubscription();
	}

	mapResults(rta) {
		// rta.ofertas.map((oferta) => {
		// 	if (oferta.ubicacion) {
		// 		oferta.ubicacion.provincia = this.toUpper(
		// 			AcordarUtils.mapProv(oferta.ubicacion.provincia.nombre, this.optsProvs)
		// 		);
		// 	}
		// });
		return rta;
	}

	selectedProv(prov) {
		return AcordarUtils.selectProv(prov, this.prov_id);
	}

	busquedaSubscription() {
		this.productoControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response: any) => {
			this.params = AcordarUtils.evaluate('producto-ean-catalogo', response, this.params);
			this.handleSearch(this.params);
		});
		this.partidoControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response: any) => {
			this.params = AcordarUtils.evaluate('ubicacion.partido.nombre_normalizado', response, this.params);
			this.handleSearch(this.params);
		});
		this.provinciaControl.valueChanges.pipe(distinctUntilChanged()).subscribe((response: any) => {
			let rta = response;
			this.optsProvs.map((opt) => {
				if (opt.gid === response.toUpperCase()) {
					return (rta = opt.gidBack);
				}
			});
			this.toggleCross(rta);
			this.params = AcordarUtils.evaluate('ubicacion.provincia.nombre_normalizado', rta, this.params);
			this.handleSearch(this.params);
		});
		this.marcaControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response: any) => {
			this.params = AcordarUtils.evaluate('producto.marca', response, this.params);
			this.handleSearch(this.params);
		});
		this.proveedorControl.valueChanges
			.pipe(debounceTime(500), distinctUntilChanged())
			.subscribe((response: any) => {
				this.params = AcordarUtils.evaluate('proveedor-cuit-razon', response, this.params);
				this.handleSearch(this.params);
			});
		this.solicitudControl.valueChanges
			.pipe(debounceTime(500), distinctUntilChanged())
			.subscribe((response: any) => {
				this.params = AcordarUtils.evaluate('acuerdo-objeto', response, this.params);
				this.handleSearch(this.params);
			});
	}

	mapIfNull(value) {
		let rta;
		if (value === null) {
			rta = 0;
		} else {
			rta = value;
		}
		return rta;
	}

	mapAhorro(value) {
		return Math.abs(Math.round(value));
	}

	toggleCross(response) {
		if (response.length > 0 && response !== 'empty') {
			this.showCross = true;
		} else {
			this.showCross = false;
			this.provinciaControl.setValue('empty');
		}
	}

	toUpper(str) {
		return AcordarUtils.capitalizeLetter(str);
	}

	getDescripcion() {
		let response;
		this.results.map((r) => {
			r.ofertas.map((o) => {
				response = o.producto.descripcion;
			});
		});
		return response;
	}

	handleSearch(params) {
		this.loadingService.show();
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		this.clearData();
		this.subscription = this.acordarService.getBuscarOfertas(1, params).subscribe(
			(response: any) => {
				if (response.result.length > 0) {
					response.result.map((r) => {
						this.acordarService.getProductoPorNumCat(r, 1, params).subscribe(
							(rta) => {
								this.loadingService.hide();
								this.results.push(this.mapResults(rta.result));
								this._results.next(this.results);
							},
							(error) => {
								this.loadingService.hide();
								this.clearData();
							}
						);
					});
				} else {
					this.clearData();
					this.loadingService.hide();
				}
				this.paginate(response);
			},
			(error) => {
				this.clearData();
				this.loadingService.hide();
			}
		);
	}

	paginate(response) {
		this.lastPage = response.paged.max_paged;
		this.pagination = AcordarUtils.createPaginationArray(response.paged.max_paged);
		this.currentPage = 1;
	}

	handleShowInfo(cuit) {
		if (this.showMasInfo === cuit) {
			this.showMasInfo = null;
		} else {
			this.showMasInfo = cuit;
		}
	}

	handleInhabilitado(cuit) {
		if (this.provInhabilitado === cuit) {
			this.provInhabilitado = null;
		} else {
			this.provInhabilitado = cuit;
			// console.log(cuit)
		}
	}

	handleMouseLeave() {
		this.precioMouseEnter.next(false);
	}

	handleMouseEnter() {
		this.precioMouseEnter.next(true);
	}

	callService(page: number, params) {
		this.currentPage = page;
		this.acordarService.getBuscarOfertas(page, params).subscribe(
			(rta) => {
				if (rta.result.length > 0) {
					rta.result.map((r) => {
						this.acordarService.getProductoPorNumCat(r, 1, params).subscribe(
							(rta) => {
								this.results.push(this.mapResults(rta.result));
								this._results.next(this.results);
								this.loadingService.hide();
							},
							(error) => {
								this.clearData();
								this.loadingService.hide();
							}
						);
					});
				} else {
					this.clearData();
					this.loadingService.hide();
				}
			},
			(error) => {
				this.clearData();
				this.loadingService.hide();
			}
		);
	}

	handlePagination(pageNumber: number) {
		this.clearData();
		this.loadingService.show();
		this.currentPage = pageNumber;
		this.callService(pageNumber, this.params);
	}

	nextPage() {
		this.clearData();
		this.loadingService.show();
		let nextPage = this.currentPage + 1;
		this.callService(nextPage, this.params);
	}

	previousPage() {
		this.clearData();
		this.loadingService.show();
		let previousPage = this.currentPage - 1;
		this.callService(previousPage, this.params);
	}

	evaluateAhorro(valor) {
		let response;
		if (('' + valor).search('-') === -1 && valor !== '0.00' && valor !== null) {
			response = false;
		} else if (valor !== '0.00' && valor !== null) {
			response = true;
		} else {
			response = null;
		}
		return response;
	}

	clearData() {
		this.results = [];
		this._results.next(this.results);
	}
}
